import ArticleInterface from "@app/Interface/ArticleInterface";
import DashboardNewsInterface from "@app/Interface/DashboardNewsInterface";
import ErrorResponseInterface from "@app/Interface/ErrorResponseInterface";
import EventInterface from "@app/Interface/EventInterface";

export default class DashboardNewsModel implements DashboardNewsInterface {
    id: number;
    events: EventInterface[] | ErrorResponseInterface;
    articles: ArticleInterface[] | ErrorResponseInterface;
    
    constructor(data?: DashboardNewsInterface) {

        this.id = data?.id ?? 0;
        this.events = data?.events ?? [];
        this.articles = data?.articles ?? [];

    }

}